export default {
    // first item in 'paths' is the default path
    normal_items: [
        {
            title: "menu.nastenka",
            img: "/img/menu/nastenka.svg",
            paths: ["/admin"],
            show: true,
            roll: false,
            subscription: 'free',
        },
        {
            title: "menu.cenovePonuky",
            img: "/img/menu/ponuky.svg",
            paths: ["/admin/offers"],
            show: true,
            roll: false,
            subscription: 'free',
        },
        {
            title: "menu.mojiKlienti",
            img: "/img/menu/klienti.svg",
            paths: ["/admin/klient"],
            show: true,
            roll: false,
            stepId: "v-step-7",
            subscription: 'free',
        },
        //{
        //     title:'menu.balicky',
        //     img: '/img/menu/balicky.svg',
        //     path: '/admin/balicky',
        //     roll: true,
        // }
    ],
    setting_items: [
        {
            title: "menu.mojeFirmy",
            img: "/img/menu/mojefirmy.svg",
            paths: ["/admin/nastavenia/firmy"],
            show: true,
            roll: false,
            subscription: 'profi',
        },
        {
            title: "menu.nastaveniaUctu",
            img: "/img/menu/nastavenia-uctu.svg",
            paths: ["/admin/nastavenia/ucet"],
            show: true,
            roll: false,
            subscription: 'free',
        },
        // {
        //     title: "menu.firmaAKontakty",
        //     img: "/img/menu/firma-a-kontakty.svg",
        //     path: "/admin/nastavenia/firma-a-kontakty",
        //     show: true,
        //     roll: false,
        // },
        {
            title: "menu.notifikacie",
            img: "/img/menu/notifikacie.svg",
            paths: ["/admin/nastavenia/notifikacie"],
            show: true,
            roll: false,
            subscription: 'free',
        },
        {
            title: "menu.integracie",
            img: "/img/menu/nastavenia-uctu.svg",
            paths: ["/admin/nastavenia/superfaktura"],
            show: true,
            roll: false,
            subscription: 'free',
        },
    ],
    premium_items: [
        {
            title: "menu.vlastneFarbyPonuky",
            img: "/img/menu/farby.svg",
            paths: ["/admin/vlastne-farby-ponuky"],
            show: true,
            roll: false,
            subscription: 'profi',
        },
        {
            title: "menu.recenzie",
            img: "/img/menu/recenzie.svg",
            paths: ["/admin/recenzie"],
            show: true,
            roll: false,
            subscription: 'free',
        },
        {
            title: "menu.mojiPouzivatelia",
            img: "/img/menu/pouzivatelia.svg",
            paths: ["/admin/pouzivatelia"],
            show: true,
            roll: false,
            subscription: 'small_team',
        },
        {
            title: "menu.polozkyACeny",
            img: "/img/menu/items.svg",
            paths: ["/admin/items"],
            show: true,
            roll: false,
            subscription: 'free',
        },
        {
            title: "menu.statistiky",
            img: "/img/menu/statistiky.svg",
            paths: ["/admin/statistics"],
            show: true,
            roll: false,
            subscription: 'profi',
        },
        {
            id: 23,
            title: "menu.subscriptions",
            img: "/img/menu/firmy.svg",
            paths: ["/admin/subscriptions/dashboard"],
            show: true,
            roll: false,
            subscription: 'free',
        }
    ],
    admin_items: [
        {
            title: "menu.blog",
            img: "/img/menu/historia.svg",
            paths: ["/admin/admin_page/blog"],
            show: true,
            roll: false,
            subscription: 'free',
        },
        {
            title: "menu.pouzivatelia",
            img: "/img/menu/pouzivatelia.svg",
            paths: ["/admin/admin_page/pouzivatelia"],
            show: true,
            roll: false,
            subscription: 'free',
        },
        {
            title: "menu.firmy",
            img: "/img/menu/firmy.svg",
            paths: ["/admin/admin_page/firmy"],
            show: true,
            roll: false,
            subscription: 'free',
        },
        {
            title: "menu.historiaBalickov",
            img: "/img/menu/historia.svg",
            paths: ["/admin/admin_page/historia-balickov"],
            show: true,
            roll: false,
            subscription: 'free',
        },
        {
            title: "menu.statistiky",
            img: "/img/menu/statistiky.svg",
            paths: ["/admin/admin_page/statistics"],
            show: true,
            roll: false,
            subscription: 'free',
        },
        {
            title: "menu.impersonating",
            img: "/img/menu/pouzivatelia.svg",
            paths: ["/admin/admin_page/impersonate"],
            show: true,
            roll: false,
            subscription: 'free',
        },
        {
            title: "menu.alerts",
            img: "/img/menu/notifikacie.svg",
            paths: ["/admin/admin_page/alerts"],
            show: true,
            roll: false,
            subscription: 'free',
        },
        {
            title: "menu.faktury",
            img: "/img/menu/historia.svg",
            paths: ["/admin/admin_page/invoices"],
            show: true,
            roll: false,
            subscription: 'free',
        },
        // {
        //     title: "menu.subscriptions",
        //     img: "/img/menu/firmy.svg",
        //     path: "/admin/subscriptions",
        //     show: true,
        //     roll: false,
        // },
    ],
};